
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import LeftNavigation from "./components/feature/LeftNavigation";
import Footer from "./components/feature/Footer";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="min-h-screen bg-white flex">
          {/* Fixed Left Navigation */}
          <LeftNavigation />
          
          {/* Main Content Area with No Left Spacing */}
          <div className="flex-1 pl-64 min-h-screen flex flex-col">
            {/* Main Content */}
            <main className="flex-1 w-full">
              <AppRoutes />
            </main>
            
            {/* Footer */}
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
